var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"exchange-list-wrap margin-top-20"},[_c('BasiceLayout',{staticClass:"withdrawal-layout",attrs:{"title":"过去7天收益","empty-text":"loading"}},[_c('ve-line',{attrs:{"data":_vm.chartData,"extend":_vm.extend,"settings":_vm.chartSettings}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }